





























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { MigrationImport } from "@/entities";

const namespace: string = "application";

@Component({
  components: {
    VJsonschemaForm,
    LeftNavigationComponent,
  },
})
export default class ApplicationFormComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() selectedTopMenu!: string;
  @Prop() schema!: any;
  @Prop() data!: any;
  @Prop() subKey!: any;
  @Prop() tags!: any;

  selectedSubMenu: string = "";

  mounted() {
    this.selectedSubMenu = Object.keys(
      this.schema["properties"][this.selectedTopMenu]["properties"]
    )[0];
  }

  change(e) {
    this.datum[e.key] = e.model;
  }
  save() {
    this.$emit("save");
  }

  get datum(): any {
    return this.data.application.projectSummary;
  }

  get subSchema() {
    if (this.schema == null || !this.schema.properties) return {};

    return this.schema.properties["application"].properties["projectSummary"];
  }
}
